import { Text } from '@fluentui/react'
import React, { PropsWithChildren } from 'react'

export const TextCell: React.FC<PropsWithChildren> = ({ children }) =>
  children ? (
    <Text styles={{ root: { textOverflow: 'ellipsis', overflow: 'hidden' } }}>
      {children}
    </Text>
  ) : null
